<div class="grid">
    <div class="col-12">
        <mat-accordion *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('w1')"
                    (closed)="onTabClose('w1')"
                    [expanded]="TabStates?.w1 == null || TabStates?.w1 == true"
                    (mouseenter)="unwatchWorkflowCalendar()"
                    (mouseleave)="watchWorkflowCalendar()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex space-x-2">
                            <div class="ml-1">
                                <div class="transition-all rotate-0 {{ TabStates.w1 ? 'rotate-90' : '' }}">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </div>
                            </div>
                            <div class="text-xl font-bold">
                                {{ 'txWorkflow.calender' | translate }}
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div *ngIf="myWorkflowCalendar == null">{{ 'txWorkflowCalender.data' | translate }}</div>
                    <div *ngIf="myWorkflowCalendar != null">
                        <tx-workflow-calendar [CalendarData]="myWorkflowCalendar"
                                              (OnRefresh)="refresh()"></tx-workflow-calendar>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <div class="col-12 xl:flex-1 xl:min-w-0">
        <mat-accordion *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('w4')"
                    (closed)="onTabClose('w4')"
                    (mouseenter)="unwatchWorkflow()"
                    (mouseleave)="watchWorkflow()"
                    [expanded]="TabStates.w4 == null || TabStates.w4 == true">

                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex space-x-2">
                            <div class="ml-1">
                                <div class="transition-all rotate-0 {{ TabStates.w4 ? 'rotate-90' : '' }}">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </div>
                            </div>
                            <div class="text-xl font-bold">
                                {{ 'txWorkflow.requests' | translate }}
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>


                <div class="scroll-indicator">
                    <i class="fa fa-angle-right blink"></i>
                    <i class="fa fa-angle-right blink"></i>
                    <i class="fa fa-angle-right blink"></i>
                </div>
                <div>
                    <div *ngIf="!myWorkflowHasData">{{ 'txWorkflow.noRequests' | translate }}</div>

                    <div *ngIf="myWorkflowHasData">
                        <div class="widget-body">
                            <div class="table-scroll">
                            <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="w-full table table-hover">
                                <ng-container matColumnDef="datum">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.date' | translate }}</th>
                                    <td mat-cell *matCellDef="let item" class="align-items-start">
                                        <div class="md:inline-block sm:flex sm:flex-column">
                                            <div>
                                                <ng-template [ngIf]="checkBisData(item.bis)">
                                                    <strong>{{ 'txTeamleiter.from' | translate }}:</strong> {{ item.von | date: 'EE dd.MM.yyyy' }}<br/>
                                                </ng-template>
                                                <ng-template [ngIf]="!checkBisData(item.bis)">
                                                    <strong>{{ 'txTeamleiter.on' | translate }}:</strong> {{ item.von | date: 'EE dd.MM.yyyy' }}<br/>
                                                </ng-template>
                                            </div>
                                            <div>
                                                <ng-template [ngIf]="checkBisData(item.bis)">
                                                    <strong>{{ 'txTeamleiter.until' | translate }}:&nbsp;</strong> {{ item.bis ? (item?.bis | date: 'EE dd.MM.yyyy') : '' }}
                                                </ng-template>
                                                <ng-template [ngIf]="!checkBisData(item.bis)">
                                                    <strong>{{ 'txTeamleiter.at' | translate }}:&nbsp;</strong> {{ item?.von | formatTime: 'HH:mm' }}
                                                </ng-template>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="typ">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.type' | translate }}</th>
                                    <td mat-cell *matCellDef="let item">{{ item.Typname }}{{ item.TypNeu }}</td>
                                </ng-container>
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.name' | translate }}</th>
                                    <td mat-cell *matCellDef="let item" class="wrap"><span [innerHTML]="item.Name"></span></td>
                                </ng-container>
                                <ng-container matColumnDef="bearbeiter">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.editor' | translate }}</th>
                                    <td mat-cell *matCellDef="let item" class="wrap"><span [innerHTML]="item.Bearbeiter"></span></td>
                                </ng-container>
                                <ng-container matColumnDef="notiz">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.note' | translate }}</th>
                                    <td mat-cell *matCellDef="let item" class="wrap"><span [innerHTML]="item.NotizAntragssteller"></span></td>
                                </ng-container>
                                <ng-container matColumnDef="antwort">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.answer' | translate }}</th>
                                    <td mat-cell *matCellDef="let item" class="wrap"><span [innerHTML]="item.NotizAntragsbearbeiter"></span></td>
                                </ng-container>
                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.state' | translate }}</th>
                                    <td mat-cell *matCellDef="let item">
                                        {{ item.Status == 0 ? ('txWorkflow.declined' | translate) : '' }}
                                        {{ item.Status == 1 ? ('txWorkflow.approved' | translate) : '' }}
                                        {{ item.Status == 99 ? ('txWorkflow.open' | translate) : '' }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let item">
                                        <div *ngIf="item.art !== 'FSC'" class="flex flex-col">
                                            <button mat-raised-button color="primary" class="w-full mb-1"
                                                (click)="onDeleteClick(item)"
                                                *ngIf="item.Status == 99 && item.Eigener == 1">{{ 'general.delete' | translate }}</button>
                                            <button mat-raised-button color="primary" class="w-full mb-1"
                                                (click)="onConfirmClick(item)"
                                                *ngIf="item.Status != 99 && item.Eigener == 1">{{ 'general.confirm' | translate }}</button>
                                            <button mat-raised-button color="primary" class="w-full mb-1"
                                                (click)="onApproveClick(item)"
                                                *ngIf="item.Status == 99 && item.Eigener == 2">{{ 'txTeamleiter.agree' | translate }}</button>
                                            <button mat-raised-button color="primary" class="w-full mb-1"
                                                (click)="onDeclineClick(item)"
                                                *ngIf="item.Status == 99 && item.Eigener == 2">{{ 'txTeamleiter.disagree' | translate }}</button>
                                        </div>
                                        <div *ngIf="item.art === 'FSC'">
                                            <button mat-raised-button color="primary" class="w-full mb-1"
                                                (click)="onConfirmClick(item)"
                                                *ngIf="item.Status != 99 && item.Eigener == 1">{{ 'general.confirm' | translate }}</button>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="expandedInfo">
                                    <td mat-cell *matCellDef="let item" [attr.colspan]="displayedColumns.length" class="wrap">
                                        <ng-container *ngIf="item.info">
                                            <strong>{{ 'txTeamleiter.info' | translate }}: </strong><span [innerHTML]="item.info"></span>
                                        </ng-container>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns"
                                    [ngClass]="{ 'border-bottom-none': row.info }"></tr>
                                <tr mat-row *matRowDef="let row; columns: expandedColumns; when: hasInfo"
                                    class="detail-row"
                                    (mouseenter)="hoverBoth($event)" (mouseleave)="hoverBoth($event)"></tr>
                            </table>
                            </div>
                            <mat-paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="col-12 xl:col-3 min-w-[400px]">
        <div class="mb-3">
            <mat-accordion *ngIf="myTabStateService.TabStates$ | async as TabStates">
                <mat-expansion-panel
                        class="mat-elevation-z0"
                        hideToggle
                        (opened)="onTabOpen('w2')"
                        (closed)="onTabClose('w2')"
                        [expanded]="TabStates.w2 == null || TabStates.w2 == true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="flex space-x-2">
                                <div class="ml-1">
                                    <div class="transition-all rotate-0 {{ TabStates.w2 ? 'rotate-90' : '' }}">
                                        <fa-icon icon="chevron-right"></fa-icon>
                                    </div>
                                </div>
                                <div class="text-xl font-bold">
                                    {{ 'txWorkflow.makeRequest' | translate }}
                                </div>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <tx-apply-booking [myFormType]="antragForm"
                                          (submitClicked)="updateFromComponent()"></tx-apply-booking>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>


        <mat-accordion *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('w3')"
                    (closed)="onTabClose('w3')"
                    [expanded]="TabStates.w3 == null || TabStates.w3 == true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex space-x-2">
                            <div class="ml-1">
                                <div class="transition-all rotate-0 {{ TabStates.w3 ? 'rotate-90' : '' }}">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </div>
                            </div>
                            <div class="text-xl font-bold">
                                {{ 'txWorkflow.requestBookings' | translate }}
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <tx-apply-booking [myFormType]="buchungForm"
                                      (submitClicked)="updateFromComponent()"></tx-apply-booking>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
